import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};
function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Abstract</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Industrialization and subsequent globalization witnessed an
              escalation in energy utilization, evident from the increase in the
              average per capita electricity consumption from 2.5 MJ d
              <sup>&minus;1</sup> to more than 200 MJ d<sup>&minus;1</sup>{" "}
              (Ramachandra &amp; Hegde, 2015). Next to electricity, the major
              energy required is the conventional non- renewable fuels such as
              refined petroleum products and natural gas for mobility in the
              transportation sector. The global primary energy consumption is
              about 25,912 quadrillion Btu in petroleum (in 2019). The biomass
              and natural gas contribution was about 1411 and 978 quadrillion
              Btu. However, the fast-perishing stock of fossil resources with
              the escalating greenhouse gas (GHG) footprint necessitates the
              inves- tigation of sustainable alternatives to meet the
              ever-increasing demand for energy in the transportation sector.
              The transition to biofuels gives the additional benefits of
              decarbonization, decentralized employment generation (and
              remediation, in the case of feedstock cultivation in wastewater),
              and the scope for economic viability through a circular economy in
              the algal refinery. Decarbonization aids in mitigating global
              warming and changes in the climate (Jaccard, 2006). Currently,
              there are numerous biofuel initiatives across the globe to reduce
              the reliance on petroleum&nbsp;fuel (Vlysidis et al., 2011)
              through decentralized local resources such as microalgae, etc.
              Biodiesel is one of the most promising biofuels shown to give
              engine performance with reduced particulate, carbon monoxide, and
              hydrocarbon emissions compared to conventional diesel (Graboski
              &amp; McCormick, 1998). Biodiesel has been produced from
              triglycerides derived from terrestrial oil seeds, animal fats, or
              algae. Biodiesel production from vegetable oils has been
              increasing during the past decade. However, the amount of oil
              produced in a hectare area from terrestrial oil seeds is limited.
              In this context, microalgae-derived oil has received significant
              attention due to its non- conflicting nature of fuel in terms of
              arable land availability or food (Ribeiro et al., 2015).
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AbstractPage;
